<!-- <template>
	<div class="nav-main">
		
		<div class="main-nav">			
			<div class="row al-c" style="padding: 25px 0px;border-bottom: 1px solid #474747;">
				<i class="el-icon-monitor" style="font-size: 24px;color: #fff;"></i>
				<div class="item-no" style="font-size: 24px;color: #fff;margin-left: 10px;">云MES平台</div>
			</div>
			<div class="row" style="align-items: flex-start;margin-top: 25px;border-bottom: 1px solid #474747;padding-bottom: 50px;">
				<div class="col-no" style="width: 200px;">
					<div class="item" style="font-weight: bold;color: #fff;">
						了解产品
					</div>
					<div class="item" @click="toProduct(1)" style="color: #767676;margin-top: 25px;cursor: pointer;">
						MES系统
					</div>
					<div class="item" @click="toProduct(2)" style="color: #767676;margin-top: 25px;cursor: pointer;">
						WES系统
					</div>
					<div class="item" @click="toProduct(3)" style="color: #767676;margin-top: 25px;cursor: pointer;">
						APS系统
					</div>
					<div class="item" @click="toProduct(4)" style="color: #767676;margin-top: 25px;cursor: pointer;">
						EAM系统
					</div>
					<div class="item" @click="toProduct(5)" style="color: #767676;margin-top: 25px;cursor: pointer;">
						SCADA系统
					</div>
				</div>
				<div class="col-no" style="width: 200px;">
					<div class="item" style="font-weight: bold;color: #fff;">
						战略伙伴
					</div>
					<a class="item" style="color: #767676;margin-top: 25px;" href="https://www.bangdao-tech.com/" target="_blank">
						邦道科技
					</a>
					<a class="item" style="color: #767676;margin-top: 25px;" href="https://www.sunmi.com/index" target="_blank">
						商米科技
					</a>
					<a class="item" style="color: #767676;margin-top: 25px;" href="http://www.chinatelecom.com.cn/" target="_blank">
						中国电信
					</a>
					<a class="item" style="color: #767676;margin-top: 25px;" href="http://www.10086.cn/index/gd/index_200_200.html" target="_blank">
						中国移动
					</a>
					<a class="item" style="color: #767676;margin-top: 25px;" href="https://www.aliyun.com" target="_blank">
						阿里云
					</a>
				</div>
				<div class="col-no" style="width: 200px;">
					<div class="item" style="font-weight: bold;color: #fff;">
						新闻资讯
					</div>
					<div class="item" @click="toNew(1)" style="color: #767676;margin-top: 25px;cursor: pointer;">
						企业新闻
					</div>
					<div class="item" @click="toNew(2)" style="color: #767676;margin-top: 25px;cursor: pointer;">
						行业资讯
					</div>
					<div class="item" style="font-weight: bold;color: #fff;margin-top: 25px;">
						客户案例
					</div>
					<div class="item" @click="route('khal')" style="color: #767676;margin-top: 25px;cursor: pointer;">
						客户案例
					</div>
					
				</div>
				<div class="col-no" style="width: 200px;">
					<div class="item" style="font-weight: bold;color: #fff;">
						关于贸宝
					</div>
					<div class="item" @click="route('gywm')" style="color: #767676;margin-top: 25px;cursor: pointer;">
						关于我们
					</div>
					<div class="item" @click="route('lianxi')" style="color: #767676;margin-top: 25px;cursor: pointer;">
						联系我们
					</div>
				</div>
				<div class="col" style="align-items: flex-end;">
					<div class="item" style="font-weight: bold;color: #fff;font-size: 20px;">
						021-59883199
					</div>
					<div class="item" style="color: #767676;margin-top: 25px;">
						周一到周日 8:30-17:30
					</div>
				</div>
			</div>
			<div class="row" style="padding-top: 20px;padding-bottom: 20px;">
				<div class="item-no" style="font-size: 16px;color: #9a9a9a9;">
					© 2021 上海贸宝信息技术有限公司 版权所有 | 沪ICP备 16006543 | 沪公安网备 31011002003742 | 反诈劝阻电话：962110
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name: "App",

		data() {
			return {

			};
		},
		created() {
		},
		methods: {
			route(name) {
				window.scrollTo(0, 0);
				this.$router.push(name);
			},
			toProduct(val){
				window.scrollTo(0, 0);
				this.$router.push('cpzx?pro='+val);
			},
			toNew(val){
				window.scrollTo(0, 0);
				this.$router.push('xwzx?type='+val);
			}
		},
		mounted() {
			
		},
	};
</script>

<style scoped>
	.nav-main {
		width: 100%;
		z-index: 500;
		background: #272727;
		/*box-shadow: 0px 2px 5px 0px rgba(116, 116, 116, 0.3);*/
	}
	
	
	
	.main-nav {
		width: 1200px;
		margin: auto;
	}
	
	
</style> -->


<template>
  <div class="footer-main">
    <div class="footer-container">
      <!-- 顶部内容区域 -->
      <div class="footer-top">
        <!-- 第一列：CHAOS -->
        <div class="footer-column">
          <div class="column-title">贸宝信息</div>
          <div class="column-item" role="link" tabindex="0" @click="route('index')" @keyup.enter="route('index')">走进贸宝</div>
          <div class="column-item" role="link" tabindex="0" @click="route('gywm')" @keyup.enter="route('gywm')">关于我们</div>
          <div class="column-item" role="link" tabindex="0" @click="route('lianxi')" @keyup.enter="route('lianxi')">联系我们</div>
        </div>

        <!-- 第二列：资源 -->
        <div class="footer-column">
          <div class="column-title">客户服务</div>
          <div class="column-item" role="link" tabindex="0" @click="route('gywm')" @keyup.enter="route('gywm')">客户案例</div>
          <div class="column-item" role="link" tabindex="0" @click="route('khal')" @keyup.enter="route('khal')">技术服务</div>
          <div class="column-item" role="link" tabindex="0" @click="route('contact')" @keyup.enter="route('contact')">预约演示</div>
        </div>

        <!-- 第三列：产品 -->
        <div class="footer-column">
          <div class="column-title">产品方案</div>
          <div class="column-item" role="link" tabindex="0" @click="route('whzlDetail')" @keyup.enter="route('whzlDetail')">智慧燃气解决方案</div>
          <div class="column-item" role="link" tabindex="0" @click="route('xjxjDetail')" @keyup.enter="route('xjxjDetail')">智慧水务解决方案</div>
          <div class="column-item" role="link" tabindex="0" @click="route('xwDetail')" @keyup.enter="route('xwDetail')">智慧工厂解决方案</div>
        </div>

        <!-- 第四列：操作 + 社交图标 -->
        <div class="footer-column">
          <!-- <div class="column-item">下载客户端</div> -->
          <div class="column-item" role="link" tabindex="0" @click="route('lianxi')" @keyup.enter="route('lianxi')">联系顾问</div>
          <!-- <img src="../../assets/img/cpzxIcon2.png" style="width: 24px; height: 24px;" /> -->
          <!-- 社交图标 -->
          <!-- <div class="social-icons"> -->
            <a class="column-item phone-link" href="tel:021-59883199">021-59883199</a>
            <!-- <i class="icon-wechat"></i> -->
            <!-- <i class="icon-weibo" ></i>
            <i class="icon-bilibili" ></i>
            <i class="icon-redbook" ></i>
            <i class="icon-zhihu"></i> -->
          <!-- </div> -->
        </div>
      </div>

      <!-- 底部版权区域 -->
      <div class="footer-bottom">
        <div class="copyright">Copyright © 2026 上海贸宝信息科技有限公司</div>
        <div class="icp-info">版权所有 | 沪ICP备 16006543 | 沪公安网备 31011002003742 | 反诈劝阻电话：962110</div>
        <!-- <div class="region-selector">
          <i class="icon-region"></i> 更改地区-简体中文
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    route(name) {
      window.scrollTo(0, 0);
      const path = name && String(name).startsWith("/") ? name : `/${name}`;
      this.$router.push(path).catch(() => {});
    },
    downloadClient() {
      // 下载客户端的逻辑
    //   alert("开始下载客户端");
    },
    contactAdvisor() {
      // 联系顾问的逻辑
    //   alert("联系顾问");
    },
    openWechat() {
      // 打开微信的逻辑
    },
    openWeibo() {
      // 打开微博的逻辑
    },
    openBilibili() {
      // 打开B站的逻辑
    },
    openRedbook() {
      // 打开小红书的逻辑
    },
    openZhihu() {
      // 打开知乎的逻辑
    },
    changeRegion() {
      // 更改地区的逻辑
    }
  }
};
</script>

<style scoped>
.footer-main {
  width: 100%;
  background: #1e1e2d; /* 深色背景，和目标图一致 */
  color: #fff;
  padding: 40px 0;
}

.footer-container {
  width: 1200px;
  margin: 0 auto;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;
  border-bottom: 1px solid #474747;
}

.footer-column {
  width: 220px;
}

.column-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 25px;
}

.column-item {
  color: #767676;
  margin-bottom: 15px;
  cursor: pointer;
  transition: color 0.2s;
}
.column-item:hover {
  color: #fff;
}

.phone-link {
  display: inline-block;
  text-decoration: none;
  color: inherit;
}
.phone-link:hover {
  color: #fff;
}

/* 社交图标 */
.social-icons {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}
.social-icons i {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.icon-wechat {
  background: #27c156;
}
.icon-weibo {
  background: #ff4545;
}
.icon-bilibili {
  background: #fb7299;
}
.icon-redbook {
  background: #ff2442;
}
.icon-zhihu {
  background: #0f88eb;
}

/* 底部区域 */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  color: #9a9a9a;
  font-size: 12px;
}

.region-selector {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}
.icon-region {
  font-size: 16px;
}
</style>